export default __webpack_public_path__ + "static/media/earning-blue.998917e4.svg";